var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNova(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2674_14564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4178 2.6931C10.4178 2.63826 10.4039 2.58431 10.3774 2.5363C10.3509 2.48829 10.3127 2.4478 10.2663 2.4186L8.065 1.0476C8.01504 1.01649 7.95736 1 7.8985 1C7.83964 1 7.78196 1.01649 7.732 1.0476L3.70075 3.5466L3.68425 3.55785C3.64227 3.58785 3.6081 3.62748 3.58461 3.67341C3.56112 3.71935 3.54899 3.77026 3.54925 3.82185V6.4041L1.53175 7.60035C1.48382 7.62906 1.44418 7.66974 1.4167 7.71838C1.38922 7.76703 1.37485 7.82198 1.375 7.87785V12.0913C1.37862 12.1441 1.39514 12.1952 1.42313 12.24C1.45112 12.2849 1.48971 12.3222 1.5355 12.3486L3.54925 13.5186V16.1526C3.54886 16.2075 3.56251 16.2616 3.58889 16.3098C3.61527 16.358 3.65352 16.3986 3.7 16.4279L7.7305 18.9524C7.78016 18.9834 7.83748 19 7.89604 19.0002C7.9546 19.0005 8.01207 18.9844 8.062 18.9538L10.2633 17.6114C10.3105 17.5823 10.3495 17.5416 10.3764 17.4931C10.4034 17.4447 10.4173 17.3901 10.417 17.3346V10.8186H9.78025V11.6721L5.56 14.2379L5.887 14.7906L9.78025 12.4236V17.1523L7.9 18.2999L6.331 17.3174L7.981 16.3229L7.6555 15.7679L5.7205 16.9349L4.18525 15.9734V13.4189L5.96575 12.3463L5.641 11.7921L3.784 12.9118L2.01175 11.8821V10.1833L3.9505 9.01335L3.625 8.45985L2.01175 9.4326V8.0616L3.8605 6.9651L5.617 8.0991V9.72735L4.3045 10.5898L4.65025 11.1298L5.90275 10.3086L7.0525 11.1246L7.417 10.5958L6.2545 9.77085V8.06835L8.17 6.8631C8.21609 6.83367 8.25401 6.79309 8.28023 6.7451C8.30645 6.69711 8.32013 6.64328 8.32 6.5886V4.54635H7.684V6.4086L5.9125 7.52535L4.18525 6.41235V4.0026L5.59 3.13035V5.16435H6.2275V2.7366L7.89775 1.70085L9.7795 2.8731V8.9781H10.417V2.6931H10.4178Z",
    fill: "url(#paint0_linear_2674_14564)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2097 10.2052C15.2862 10.6191 15.5146 10.9894 15.8501 11.2436C16.1856 11.4977 16.6039 11.6173 17.0231 11.5789C17.4422 11.5405 17.8318 11.3468 18.1156 11.0359C18.3993 10.725 18.5565 10.3193 18.5565 9.89844C18.5565 9.47755 18.3993 9.07185 18.1156 8.76095C17.8318 8.45006 17.4422 8.2564 17.0231 8.21798C16.6039 8.17957 16.1856 8.29917 15.8501 8.55332C15.5146 8.80747 15.2862 9.17781 15.2097 9.59169H9.04541V10.2052H15.2104H15.2097ZM17.9434 9.89769C17.9472 10.0411 17.9222 10.1838 17.87 10.3173C17.8177 10.4509 17.7393 10.5727 17.6392 10.6754C17.5391 10.7782 17.4195 10.8598 17.2873 10.9156C17.1552 10.9713 17.0132 11.0001 16.8698 11.0001C16.7264 11.0001 16.5844 10.9713 16.4522 10.9156C16.3201 10.8598 16.2005 10.7782 16.1004 10.6754C16.0003 10.5727 15.9218 10.4509 15.8696 10.3173C15.8173 10.1838 15.7924 10.0411 15.7962 9.89769C15.8036 9.61786 15.9199 9.35198 16.1205 9.15667C16.321 8.96136 16.5899 8.85207 16.8698 8.85207C17.1497 8.85207 17.4186 8.96136 17.6191 9.15667C17.8197 9.35198 17.936 9.61786 17.9434 9.89769Z",
    fill: "url(#paint1_linear_2674_14564)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5683 12.0451H11.0396V11.4316H15.1818V14.4999H16.4096V17.5681H13.3413V14.5006H14.5683V12.0451ZM13.9548 16.9546V15.1134H15.7953V16.9546H13.9548Z",
    fill: "url(#paint2_linear_2674_14564)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5683 7.75033H11.0396V8.36383H15.1818V5.29633H16.9631L14.8751 1.95508L12.7878 5.29483H14.5683V7.75033ZM14.8758 3.11308L13.8941 4.68283H15.8553L14.8758 3.11308Z",
    fill: "url(#paint3_linear_2674_14564)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2674_14564",
    x1: 3.625,
    y1: 3.62535,
    x2: 16.375,
    y2: 17.1254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43E3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AA4BFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FC5978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2674_14564",
    x1: 3.62516,
    y1: 3.62544,
    x2: 16.3752,
    y2: 17.1254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43E3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AA4BFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FC5978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2674_14564",
    x1: 3.62505,
    y1: 3.62489,
    x2: 16.3751,
    y2: 17.1249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43E3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AA4BFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FC5978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2674_14564",
    x1: 3.62505,
    y1: 3.62533,
    x2: 16.3751,
    y2: 17.1253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43E3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AA4BFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FC5978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D32"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2674_14564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNova);
export default __webpack_public_path__ + "static/media/nova.6d04b03c796150d65105a5c6fcda80c3.svg";
export { ForwardRef as ReactComponent };